import request from "@/utils/request";

/**
 * 获取-隐私政策
 * @param pram
 */
export function getPrivacyApi() {
  return request({
    url: "agreement/privacy",
    method: "GET",
  });
}

/**
 * 获取-首页顶部广告
 * @param pram
 */
export function getIndexBannerApi() {
  return request({
    url: "webSite/index/banner",
    method: "GET",
  });
}
